import {
  commonUrl,
  getBanksUrl,
  getRemainingBanksUrl,
  getBranchNamesUrl,
  getBranchesUrl,
  BANK_GROUPS_URL,
  VDS_KEY,
} from "common/constants/apiUrls";
import { getData, downloadData, postData } from "networkManager/NetworkManager";

export const getAllBankslist = (bankgroupId) => {
  let url = getBanksUrl(bankgroupId);
  return getData(url);
};
export const getRemainingBankslist = (bankgroupId) => {
  let url = getRemainingBanksUrl(bankgroupId);
  return getData(url);
};
export const getAllBranchlist = (bankgroupId, bankId) => {
  let url = getBranchesUrl(bankgroupId, bankId);
  return getData(url);
};

export const getAllBranchesNames = (bankgroupId, bankId) => {
  let url = getBranchNamesUrl(bankgroupId, bankId);
  return getData(url);
};

export const getBanksWithBranches = () => {
  return getData(commonUrl.branches);
};
export const downloadBankData = (bankGroupId, bankId, type, filters) => {
  let productFilterString = "";
  filters?.products?.forEach((el) => {
    productFilterString += `&ProductKey=${el}`;
  });
  return downloadData(
    `${BANK_GROUPS_URL}/${bankGroupId}/banks/${bankId}/users/download?type=${type}${productFilterString}`
  );
};
export const invoicesRequest = (bankGroupId, bankId, type) => {
  return postData(
    `${BANK_GROUPS_URL}/${bankGroupId}/banks/${bankId}/users/invoice`
  );
};
export const downloadInvoicesData = (bankId, userId, token) => {
  return getData(`${VDS_KEY}/${bankId}/${userId}/download?tokenId=${token}`);
};
export const getSecretKey = () => {
  return getData(`${VDS_KEY}/secret`);
};
